import type { ILayerProps, IPoint } from '@/version-types';

interface IRef<T> {
    current: T;
}

interface ICancelable {
    cancel(): void;
}

export interface IBrushDrawInteractionRefs {
    mousedownInStage: IRef<boolean>;
    mousePoints: IRef<IPoint[]>;
    mouseStagePoints: IRef<IPoint[]>;
    preview: IRef<ILayerProps | undefined>;
    brushUrlPath: IRef<string>;
    isVectorLayer: IRef<boolean>;
    isDrawing: IRef<boolean>;
    mouseMoveHandle: IRef<ICancelable | null>;
}

/** 清空一轮 Brush 绘制的所有可变交互数据。 */
export function resetBrushDrawInteraction(
    refs: IBrushDrawInteractionRefs,
    setPreviewLayer: (layer: ILayerProps | null) => void,
    setPenPoint: (point: IPoint | null) => void,
) {
    refs.mouseMoveHandle.current?.cancel();
    refs.mouseMoveHandle.current = null;
    refs.mousedownInStage.current = false;
    refs.mousePoints.current.length = 0;
    refs.mouseStagePoints.current.length = 0;
    refs.preview.current = undefined;
    refs.brushUrlPath.current = '';
    refs.isVectorLayer.current = false;
    refs.isDrawing.current = false;
    setPreviewLayer(null);
    setPenPoint(null);
}

/** 为异步路径和延迟关闭划定配置代际边界。 */
export class BrushDrawLifecycle {
    private generation = 0;
    private closeTimer: ReturnType<typeof setTimeout> | null = null;

    get currentGeneration() {
        return this.generation;
    }

    reset() {
        this.generation += 1;
        this.cancelScheduledClose();
        return this.generation;
    }

    isCurrent(generation: number) {
        return generation === this.generation;
    }

    scheduleClose(generation: number, close: () => void, delay = 50) {
        this.cancelScheduledClose();
        this.closeTimer = setTimeout(() => {
            this.closeTimer = null;
            if (this.isCurrent(generation)) close();
        }, delay);
    }

    cancelScheduledClose() {
        if (this.closeTimer === null) return;
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
    }
}
